import styles from './BadgedShort.module.css'
import Score from 'shared-components/ui/Score'
import clsx from 'clsx'
import { BasicStyledComponent, DSImage } from 'shared-definitions/types'
import AppImage from 'shared-components/ui/AppImage'

interface BadgedShortProps extends BasicStyledComponent {
  title: string
  bottomLine: string
  score: number | null
  image: DSImage
}

const BadgedShort: React.VFC<BadgedShortProps> = ({
  className,
  title,
  bottomLine,
  score,
  image,
}) => (
  <div className={clsx(styles.container, className, { [styles.hasBadge]: image !== null })}>
    {image ? (
      <AppImage
        layout="raw"
        image={image}
        className={styles.imageContainer}
        imageClassName={styles.image}
        sizes={[{ bp: 'md', val: 150 }, 100]}
      />
    ) : null}
    <div className={styles.header}>
      <h2 className={styles.title}>{title}</h2>
      {score ? <Score className={styles.score} score={score} /> : null}
    </div>
    <div className={styles.bottomLine}>{bottomLine}</div>
  </div>
)

export default BadgedShort
